<template>
	<div ref="el" data-component="top-note">
		<div :class="`content ${dark ? 'dark' : ''}`">
			<Icon :slug="icon" size="s" />
			<span class="-uppertitle -uppercase title">{{ title }}</span>
		</div>
	</div>
</template>

<script setup>
import { Icon } from '~/components/core'

const props = defineProps({
	title: { type: String, default: undefined },
	icon: { type: String, default: undefined },
	dark: { type: Boolean, default: false },
})

const el = ref(null)
const context = inject('pageContext')

const setup = () => {}
const init = () => {}
const kill = () => {}

onBeforeUnmount(() => {})
onMounted(() => {})
</script>

<style lang="scss" scoped>
[data-component='top-note'] {
	position: absolute;

	top: 0;
	width: 100%;

	display: flex;
	justify-content: center;

	padding: rs(42, 42);

	z-index: 10;

	.content {
		display: flex;
		align-items: center;
		height: fit-content;

		gap: rs(12, 6);

		color: var(--color-geral-creme);
		--icon-color: var(--color-geral-creme);

		&.dark {
			color: var(--color-geral-brown);
			--icon-color: var(--color-geral-brown);
		}

		.title {
			margin-top: 1px;
		}
	}
}
</style>
